var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.header},[(_vm.page || _vm.page === 0)?_c('PageIndicator',{attrs:{"index":_vm.page}}):_vm._e(),_c('h2',{domProps:{"textContent":_vm._s(_vm.title)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }